<mat-dialog-content class="dialog-content">
  <section class="app-wrapper">
    <section class="heading-section">
      <h2>{{ DialogTitles.EDIT_EVENT }}</h2>
      <p>{{ EventsMessages.EDIT_EVENT }}</p>
    </section>

    <section class="form-content">
      <app-event-information-form
        [eventForm]="eventForm"
        [locations]="data.locations"
        [eventTypes]="eventTypes"
        [createAddressForm]="createAddressForm.bind(this)"
        [allLocations]="data.allLocations"
        [isEdit]="isEdit"
        [back]="back"
      ></app-event-information-form>
    </section>
  </section>
</mat-dialog-content>

<mat-dialog-actions class="footer invite-dialog-buttons">
  <button
    id="cancel-button"
    mat-flat-button
    color="accent"
    class="footer-button cancel-button"
    (click)="onCancel()"
  >
    {{ButtonAction.CANCEL}}
  </button>
  <button
    id="update-button"
    mat-flat-button
    color="primary"
    class="footer-button update-button"
    [disabled]="!eventForm.valid"
    (click)="onUpdate()"
  >
    <span class="button-text-full">{{ButtonAction.UPDATE_EVENT}}</span>
    <span class="button-text-short">{{ ButtonAction.UPDATE }}</span>
  </button>
</mat-dialog-actions>